(function(){
	'use strict';
	angular.module('myApp')
	.filter('dateToISO', function() {
		return function(input) {
			// usage: | dateToISO | date:'mediumDate'
			if(input == undefined) return '';
			try{
				var ISOString = moment(input).toISOString();
			} catch(err) {
				console.error(err);
				return '';
			}
			return ISOString;
		};
	})
	.filter('dateAgo', function() {
		return function(timeStamp, maskAgo) {
			// usage: | dateAgo[:true/false]
			if(timeStamp == undefined) return '';
			if (maskAgo == undefined) {
				maskAgo = false;
			}
			try{
				var ISOString = moment(timeStamp).fromNow(maskAgo);
			} catch(err) {
				console.error(err);
				return '';
			}
			return ISOString;
		};
	})
	.filter('time', function() {
		// usage:  | time:'mm':'hhh mmm':false"
		var conversions = {
			'ss': angular.identity,
			'mm': function(value) { return value * 60; },
			'hh': function(value) { return value * 3600; }
		};

		var padding = function(value, length) {
			var zeroes = length - ('' + (value)).length,
					pad = '';
			while(zeroes-- > 0) pad += '0';
			return pad + value;
		};

		return function(value, unit, format, isPadded) {
			var totalSeconds = conversions[unit || 'ss'](value),
				hh = Math.floor(totalSeconds / 3600),
				mm = Math.floor((totalSeconds % 3600) / 60),
				ss = totalSeconds % 60,
				hours	= (hh != 1) ? 's' : '',
				mins	= (mm != 1) ? 's' : '',
				secs	= (ss != 1) ? 's' : '';

			format = format || 'hh:mm:ss';
			isPadded = angular.isDefined(isPadded)? isPadded: true;
			hh = isPadded? padding(hh, 2): hh;
			mm = isPadded? padding(mm, 2): mm;
			ss = isPadded? padding(ss, 2): ss;

			return format.replace(/hh/, hh).replace(/mm/, mm).replace(/ss/, ss)
				.replace(/our\(s\)/, 'our'+hours).replace(/inute\(s\)/, 'inute'+mins).replace(/econd\(s\)/, 'econd'+secs);
		};
	})
	.filter('secondsToDateTime', function() {
		// USAGE:  | secondsToDateTime | date:'HH:mm:ss'
		return function(seconds) {
			var d = new Date(0,0,0,0,0,0,0);
			d.setSeconds(seconds);
			return d;
		};
	})
	.filter('phone', function() {
		return function (input) {
			var number = 0;

			if (!input){
				return '';
			}
			var value = input.toString().trim().replace(/^\+/, '');
			if (value.match(/[^0-9]/)) {
				return input;
			}
			switch (value.length) {
				default:
					number = value;
			}
			if(number){
				if(number.length>3){
					number = '(' + number.slice(0, 3) + ') ' + number.slice(3,6) + '-' + number.slice(6,10);
				}
			}
			return number;
		};
	})
	.filter('toTrusted', ['$sce', function($sce){
		return function(text) {
			return $sce.trustAsHtml(text);
		};
	}])
	.filter('nl2br', function($sce){
		/*
		# Usage in html template:
		"xxx | nl2br"
		<div ng-bind-html=" YourString | nl2br "></div>
		or:
		"xxx | nl2br:Boolean"
		Boolean( true or flase or just keep null) means is xhtml  or not
		if is xhtml, replace with <br/> ; if not , replace with <br>
		<div ng-bind-html=" YourString | nl2br:true "></div>
		*/
		return function(msg,is_xhtml) {
			var is_xhtml = is_xhtml || true;
			var breakTag = (is_xhtml) ? '<br />' : '<br>';
			var msg = (msg + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
			return $sce.trustAsHtml(msg);
		}
	})
    .filter('parseUrl', function($sce) {
        var urls = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim
        var emails = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim

        return function(text) {
			if(text.match(urls)) {
                text = text.replace(urls, "<a href=\"$1\" target=\"_blank\">$1</a>")
            }
            if(text.match(emails)) {
                text = text.replace(emails, "<a href=\"mailto:$1\">$1</a>")
            }

            return $sce.trustAsHtml(text)
		}
	})
	.filter('trustThisUrl', function($sce){
		return function (val) {
			return $sce.trustAsResourceUrl(val);
		};
	});
})();

//# sourceMappingURL=_mvmntfilters.js.map
